import { createEntityAdapter } from '@reduxjs/toolkit';

const usersAdapter = createEntityAdapter();

export default usersAdapter;
